import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { RemoveUserFromDealershipForOwnerReqV1 } from './types';

function useUrlQuery(dealershipQuery: RemoveUserFromDealershipForOwnerReqV1 | undefined): string | undefined {
  if (dealershipQuery === undefined) {
    return undefined;
  }

  if (dealershipQuery.userId !== undefined && dealershipQuery.userId != '') {
    return `?dealershipId=${dealershipQuery.dealershipId}&userId=${dealershipQuery.userId}&ownerUserid=${dealershipQuery.ownerUserid}`;
  }
  if (dealershipQuery.userEmail !== undefined && dealershipQuery.userEmail != '') {
    return `?dealershipId=${dealershipQuery.dealershipId}&userEmail=${dealershipQuery.userEmail}&ownerUserid=${dealershipQuery.ownerUserid}`;
  }
  return undefined;
}

async function removeUserFromDealershipForOwner(
  queryObject: RemoveUserFromDealershipForOwnerReqV1 | undefined,
): Promise<void> {
  if (queryObject === undefined) {
    throw new Error('Undefinedvalue');
  }
  const url = `${serviceConfig.endpoints.legacy.root}${
    serviceConfig.endpoints.legacy.dealerships
  }/removeuserfromdealershipforowner1${useUrlQuery(queryObject)}`;

  console.log('Complete url');
  console.log(url);
  let result = null;

  try {
    const response = await axiosInstance.delete(url);
    result = response.data;
    console.log(result);
  } catch (err) {
    console.log(err);
    throw new Error('Error removing user from dealership');
  }

  return result;
}

export default removeUserFromDealershipForOwner;
